export const SvgSelectCheck = () => (
  <svg viewBox="0 0 10 7" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true" className="m_8ee53fc2">
    <path
      d="M4 4.586L1.707 2.293A1 1 0 1 0 .293 3.707l3 3a.997.997 0 0 0 1.414 0l5-5A1 1 0 1 0 8.293.293L4 4.586z"
      fill="currentColor"
      fillRule="evenodd"
      clipRule="evenodd"
    ></path>
  </svg>
);

export const SvgArrow = () => (
  <svg width="20" height="20" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M17 10L15.2527 11.763C13.8592 13.1689 13.1625 13.8719 12.3133 13.9801C12.1053 14.0066 11.8947 14.0066 11.6867 13.9801C10.8375 13.8719 10.1408 13.1689 8.74731 11.763L7 10"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
    />
  </svg>
);

const SvgChinaFlag = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    xmlnsXlink="http://www.w3.org/1999/xlink"
    id="flag-icons-cn"
    viewBox="0 0 640 480"
  >
    <defs>
      <path id="cn-a" fill="#ff0" d="M-.6.8 0-1 .6.8-1-.3h2z" />
    </defs>
    <path fill="#ee1c25" d="M0 0h640v480H0z" />
    <use xlinkHref="#cn-a" width="30" height="20" transform="matrix(71.9991 0 0 72 120 120)" />
    <use xlinkHref="#cn-a" width="30" height="20" transform="matrix(-12.33562 -20.5871 20.58684 -12.33577 240.3 48)" />
    <use xlinkHref="#cn-a" width="30" height="20" transform="matrix(-3.38573 -23.75998 23.75968 -3.38578 288 95.8)" />
    <use xlinkHref="#cn-a" width="30" height="20" transform="matrix(6.5991 -23.0749 23.0746 6.59919 288 168)" />
    <use xlinkHref="#cn-a" width="30" height="20" transform="matrix(14.9991 -18.73557 18.73533 14.99929 240 216)" />
  </svg>
);

const SvgJapanFlag = () => (
  <svg xmlns="http://www.w3.org/2000/svg" id="flag-icons-jp" viewBox="0 0 640 480">
    <defs>
      <clipPath id="jp-a">
        <path fillOpacity=".7" d="M-88 32h640v480H-88z" />
      </clipPath>
    </defs>
    <g fillRule="evenodd" strokeWidth="1pt" clipPath="url(#jp-a)" transform="translate(88 -32)">
      <path fill="#fff" d="M-128 32h720v480h-720z" />
      <circle cx="523.1" cy="344.1" r="194.9" fill="#bc002d" transform="translate(-168.4 8.6)scale(.76554)" />
    </g>
  </svg>
);

const SvgKoreaFlag = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    xmlnsXlink="http://www.w3.org/1999/xlink"
    id="flag-icons-kr"
    viewBox="0 0 640 480"
  >
    <defs>
      <clipPath id="kr-a">
        <path fillOpacity=".7" d="M-95.8-.4h682.7v512H-95.8z" />
      </clipPath>
    </defs>
    <g fillRule="evenodd" clipPath="url(#kr-a)" transform="translate(89.8 .4)scale(.9375)">
      <path fill="#fff" d="M-95.8-.4H587v512H-95.8Z" />
      <g transform="rotate(-56.3 361.6 -101.3)scale(10.66667)">
        <g id="kr-c">
          <path id="kr-b" fill="#000001" d="M-6-26H6v2H-6Zm0 3H6v2H-6Zm0 3H6v2H-6Z" />
          <use xlinkHref="#kr-b" width="100%" height="100%" y="44" />
        </g>
        <path stroke="#fff" d="M0 17v10" />
        <path fill="#cd2e3a" d="M0-12a12 12 0 0 1 0 24Z" />
        <path fill="#0047a0" d="M0-12a12 12 0 0 0 0 24A6 6 0 0 0 0 0Z" />
        <circle cy="-6" r="6" fill="#cd2e3a" />
      </g>
      <g transform="rotate(-123.7 191.2 62.2)scale(10.66667)">
        <use xlinkHref="#kr-c" width="100%" height="100%" />
        <path stroke="#fff" d="M0-23.5v3M0 17v3.5m0 3v3" />
      </g>
    </g>
  </svg>
);

const SvgEnglishFlag = () => (
  <svg xmlns="http://www.w3.org/2000/svg" id="flag-icons-us" viewBox="0 0 640 480">
    <path fill="#bd3d44" d="M0 0h640v480H0" />
    <path stroke="#fff" strokeWidth="37" d="M0 55.3h640M0 129h640M0 203h640M0 277h640M0 351h640M0 425h640" />
    <path fill="#192f5d" d="M0 0h364.8v258.5H0" />
    <marker id="us-a" markerHeight="30" markerWidth="30">
      <path fill="#fff" d="m14 0 9 27L0 10h28L5 27z" />
    </marker>
    <path
      fill="none"
      markerMid="url(#us-a)"
      d="m0 0 16 11h61 61 61 61 60L47 37h61 61 60 61L16 63h61 61 61 61 60L47 89h61 61 60 61L16 115h61 61 61 61 60L47 141h61 61 60 61L16 166h61 61 61 61 60L47 192h61 61 60 61L16 218h61 61 61 61 60z"
    />
  </svg>
);

export const COUNTRY_FLAG_MAP = {
  en: SvgEnglishFlag,
  ja: SvgJapanFlag,
  ko: SvgKoreaFlag,
  'zh-Hans': SvgChinaFlag,
};
